import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import useCustomLogin from "../../hooks/useCustomLogin";

const Loading = () => (
  <div className="flex justify-center items-center h-screen w-full">
    <div className="animate-spin border-t-2 border-b-2 border-blue-500 rounded-full w-8 h-8"></div>
    <span className="ml-2">Loading...</span>
  </div>
);

// Lazy loaded components
const Dashboard = lazy(() =>
  import("../../pages/app/performance/dashboard/DashboardPage")
);
const Goal = lazy(() => import("../../pages/app/performance/goal/GoalPage"));
const GoalOverview = lazy(() =>
  import("../../pages/app/performance/goal/GoalOverview")
);
// const GoalRequest = lazy(() =>
//   import("../../pages/app/performance/goal/GoalRequests")
// );

const DashboardTeam = lazy(() =>
  import("../../pages/app/performance/dashboard/DashboardTeam")
);
const DashboardMy = lazy(() =>
  import("../../pages/app/performance/dashboard/DashboardMy")
);
const DashboardAll = lazy(() =>
  import("../../pages/app/performance/dashboard/DashboardAll")
);
// const GoalRequestMy = lazy(() =>
//   import("../../pages/app/performance/goal/GoalRequestMyPage")
// );

// const GoalRequestTeam = lazy(() =>
//   import("../../pages/app/performance/goal/GoalRequestTeamPage")
// );

// const GoalRequestAll = lazy(() =>
//   import("../../pages/app/performance/goal/GoalRequestAllPage")
// );

const GoalMy = lazy(() => import("../../pages/app/performance/goal/GoalMy"));
const GoalTeam = lazy(() =>
  import("../../pages/app/performance/goal/GoalTeam")
);
const GoalAll = lazy(() => import("../../pages/app/performance/goal/GoalAll"));

const Review = lazy(() =>
  import("../../pages/app/performance/review/ReviewPage")
);

const ReviewMy = lazy(() =>
  import("../../pages/app/performance/review/ReviewMyPage")
);

const ReviewTeam = lazy(() =>
  import("../../pages/app/performance/review/ReviewTeamPage")
);

const ReviewAll = lazy(() =>
  import("../../pages/app/performance/review/ReviewAllPage")
);

const ReviewProgressMy = lazy(() =>
  import("../../pages/app/performance/review/ReviewProgressMyPage")
);

const ReviewProgressTeam = lazy(() =>
  import("../../pages/app/performance/review/ReviewProgressTeamPage")
);

const ReviewProgressAll = lazy(() =>
  import("../../pages/app/performance/review/ReviewProgressAllPage")
);

const ReviewTerminatedMy = lazy(() =>
  import("../../pages/app/performance/review/ReviewTerminatedMyPage")
);

const ReviewTerminatedTeam = lazy(() =>
  import("../../pages/app/performance/review/ReviewTerminatedTeamPage")
);

const ReviewTerminatedAll = lazy(() =>
  import("../../pages/app/performance/review/ReviewTerminatedAllPage")
);

const Evaluation = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationPage")
);

const EvaluationMy = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationMyPage")
);

const EvaluationTeam = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationTeamPage")
);

const EvaluationAll = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationAllPage")
);

const EvaluationProgressMy = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationProgressMyPage")
);

const EvaluationProgressTeam = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationProgressTeamPage")
);

const EvaluationProgressAll = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationProgressAllPage")
);

const EvaluationTerminatedMy = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationTerminatedMyPage")
);

const EvaluationTerminatedTeam = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationTerminatedTeamPage")
);

const EvaluationnTerminatedAll = lazy(() =>
  import("../../pages/app/performance/evaluation/EvaluationTerminatedAllPage")
);

// 기본 Route Protection 컴포넌트
const ProtectedRoute = ({ children }) => {
  const { loginInfo } = useCustomLogin();

  if (!loginInfo) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const performanceRouter = () => {
  return [
    {
      path: "",
      element: <Navigate to="/app/performance/dashboard" replace />,
    },
    {
      path: "dashboard",
      element: (
        <ProtectedRoute>
          <Suspense fallback={<Loading />}>
            <Dashboard />
          </Suspense>
        </ProtectedRoute>
      ),
      children: [
        // {
        //     path: '',
        //     element: <Navigate to="my" replace />
        // },
        {
          path: "my",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <DashboardMy />
              </Suspense>
            </ProtectedRoute>
          ),
        },
        {
          path: "team",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <DashboardTeam />
              </Suspense>
            </ProtectedRoute>
          ),
        },
        {
          path: "all",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <DashboardAll />
              </Suspense>
            </ProtectedRoute>
          ),
        },
      ],
    },
    {
      path: "goal",
      element: (
        <ProtectedRoute>
          <Suspense fallback={<Loading />}>
            <Goal />
          </Suspense>
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: <Navigate to="overview" replace />,
        },
        {
          path: "overview",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <GoalOverview />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "",
              element: <Navigate to="my" replace />,
            },
            {
              path: "my",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <GoalMy />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "team",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <GoalTeam />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "all",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <GoalAll />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
        // {
        //   path: "request",
        //   element: (
        //     <ProtectedRoute>
        //       <Suspense fallback={<Loading />}>
        //         <GoalRequest />
        //       </Suspense>
        //     </ProtectedRoute>
        //   ),
        //   children: [
        //     {
        //       path: "my",
        //       element: (
        //         <ProtectedRoute>
        //           <Suspense fallback={<Loading />}>
        //             <GoalRequestMy />
        //           </Suspense>
        //         </ProtectedRoute>
        //       ),
        //     },
        //     {
        //       path: "team",
        //       element: (
        //         <ProtectedRoute>
        //           <Suspense fallback={<Loading />}>
        //             <GoalRequestTeam />
        //           </Suspense>
        //         </ProtectedRoute>
        //       ),
        //     },
        //     {
        //       path: "all",
        //       element: (
        //         <ProtectedRoute>
        //           <Suspense fallback={<Loading />}>
        //             <GoalRequestAll />
        //           </Suspense>
        //         </ProtectedRoute>
        //       ),
        //     },
        //   ],
        // },
      ],
    },
    {
      path: "review",
      element: (
        <ProtectedRoute>
          <Suspense fallback={<Loading />}>
            <Review />
          </Suspense>
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: <Navigate to="my" relative />,
        },
        {
          path: "my",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <ReviewMy />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "", // 추가: 기본 경로
              element: <Navigate to="progress" relative />, // progress로 리다이렉트
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewProgressMy />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewTerminatedMy />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
        {
          path: "team",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <ReviewTeam />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "",
              element: <Navigate to="progress" relative />,
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewProgressTeam />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewTerminatedTeam />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
        {
          path: "all",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <ReviewAll />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "", // 추가: 기본 경로
              element: <Navigate to="progress" relative />, // progress로 리다이렉트
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewProgressAll />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <ReviewTerminatedAll />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
      ],
    },
    {
      path: "evaluation",
      element: (
        <ProtectedRoute>
          <Suspense fallback={<Loading />}>
            <Evaluation />
          </Suspense>
        </ProtectedRoute>
      ),
      children: [
        {
          path: "",
          element: <Navigate to="my" relative />,
        },
        {
          path: "my",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <EvaluationMy />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "", // 추가: 기본 경로
              element: <Navigate to="progress" relative />, // progress로 리다이렉트
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationProgressMy />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationTerminatedMy />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
        {
          path: "team",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <EvaluationTeam />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "",
              element: <Navigate to="progress" relative />,
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationProgressTeam />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationTerminatedTeam />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
        {
          path: "all",
          element: (
            <ProtectedRoute>
              <Suspense fallback={<Loading />}>
                <EvaluationAll />
              </Suspense>
            </ProtectedRoute>
          ),
          children: [
            {
              path: "", // 추가: 기본 경로
              element: <Navigate to="progress" relative />, // progress로 리다이렉트
            },
            {
              path: "progress",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationProgressAll />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
            {
              path: "terminated",
              element: (
                <ProtectedRoute>
                  <Suspense fallback={<Loading />}>
                    <EvaluationnTerminatedAll />
                  </Suspense>
                </ProtectedRoute>
              ),
            },
          ],
        },
      ],
    },
  ];
};

export default performanceRouter;
